import { MAX_FILE_SIZE } from 'constants/files';

function isFileSizeValid(file: File) {
  if (file.size > MAX_FILE_SIZE) {
    return false;
  }

  return true;
}

export default isFileSizeValid;
